/* global noScroll */
// ===========================================================================
// APERTURA FILTRI
// ===========================================================================
$('#filter-box').on('click', '.titolo-filtri', function () {
  $(this).next('.lista-filtri').toggleClass('hidden');
});


// ===========================================================================
// NASCONDO I FILTRI SE E' PRESENTE UN SOLO ELEMENTO DA SELEZIONARE
// ===========================================================================
$('ul.sub-filters').each(function () {
  if ($(this).children('li').length === 1) {
    $(this).parents('.lista-filtri').css('display', 'none');
  }
});


// ===========================================================================
// GESTIONE FILTRI DA MOBILE
// ===========================================================================
$('#mobile-filter').on('click', function () {
  // $('#filter-box').css('left', '0');
  $('#filter-box').css('transform', 'translateX(100%)');
  noScroll(1); // attivo il noscroll sul body
});
$('#close-filter').on('click', function () {
  // $('#filter-box').css('left', '-100%');
  $('#filter-box').css('transform', 'translateX(-100%)');
});
$('#apply-filter').on('click', function () {
  // $('#filter-box').css('left', '-100%');
  $('#filter-box').css('transform', 'translateX(-100%)');
  noScroll(0); // disattivo il noscroll sul body
});


// ===========================================================================
// GESTIONE SOTTO-CATEGORIE DA MOBILE
// ===========================================================================
$('#mobile-categories').on('click', function () {
  // $('#sub-categories').css('left', '0');
  $('#sub-categories').css('transform', 'translateX(100%)');
  noScroll(1); // attivo il noscroll sul body
});
$('#close-categories').on('click', function () {
  // $('#sub-categories').css('left', '-100%');
  $('#sub-categories').css('transform', 'translateX(-100%)');
  noScroll(0); // disattivo il noscroll sul body
});


/*
// ===========================================================================
// GESTIONE PULSANTE / AREA SOTTOCATEGORIE
// ===========================================================================
*/
// Quando non sono presenti sottocategorie nella gallery da tablet / desktop
// nascondo l'area della lista ed aggiungo un margine al pulsante indietro,
// da mobile invece nascondo il pulsante trigger del menu e rendo il pulsante
// dei filtri a grandezza intera (12).
if ($('#sub-categories ul li').length >= 1) { // controllo sottocategorie
} else {
  $('#sub-categories').css('display', 'none');
  $('#mobile-categories').parent().css('display', 'none');
  $('#mobile-filter').parent().css({
    padding: '0',
    width: '100%'
  });
  $('#gallery-back').css('margin-bottom', '30px');
}

// ===========================================================================
// GESTIONE DIMENSIONE SLIDER SOTTOCATEGORIE
// ===========================================================================
if ($('.gallery-subcategories')) {
  const dim = $('.category-box').length * 16;
  $('.gallery-subcategories .row').css('width', '' + dim + 'rem');
}
